<template>
  <div
    v-if="upsell.isEligible"
    class="flex items-center gap-1 bg-green-200 rounded-2xl pr-3 py-2.5 mx-2"
  >
    <div class="w-20 h-24 shrink-0 overflow-hidden rounded-xl">
      <img
        v-if="upsell.product?.featured_image"
        :src="upsell.product.featured_image"
        alt="Protein Pack"
        class="w-full h-full object-cover"
        width="200"
        height="200"
      >
    </div>
    <div class="flex flex-col grow min-w-0 gap-2.5">
      <p class="font-bold text-base leading-none">
        Add 10g protein to each flavor with our Protein Packs.
      </p>
      <div class="flex items-center justify-between">
        <button
          class="text-sm font-semibold text-left"
          @click="showModal = true"
        >
          Learn More
        </button>
        <button
          class="bg-white border border-green-500 text-black text-sm font-semibold rounded-full px-2 py-1 whitespace-nowrap shrink-0"
          @click="upsell.add()"
        >
          Add {{ upsell.displayPackCount }} Packs – {{ formatCents(upsell.upsellPriceCents) }}
        </button>
      </div>
    </div>
  </div>

  <ProteinPackLearnMoreModal v-model="showModal" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useProteinPackUpsellStore } from '@/stores'
import { formatCents } from '@/utils/formatters'
import ProteinPackLearnMoreModal from './protein-pack-learn-more-modal.vue'

const upsell = useProteinPackUpsellStore()
const showModal = ref(false)
</script>
